module.exports = __webpack_public_path__ + "static/product-family-home-extra extra-caramel-5132bc4165de68a9a54c761789085c1c.png";